import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/xmark.svg'


const _hoisted_1 = {
  key: 0,
  class: "stand-dialog"
}
const _hoisted_2 = {
  class: "stand-dialog-container",
  ref: "container"
}
const _hoisted_3 = { class: "close-button" }
const _hoisted_4 = { class: "stand-frame-container" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeDialog($event)))
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("iframe", {
              src: _ctx.backendUrl+_ctx.stand.id
            }, null, 8, _hoisted_5)
          ])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}